import {
    BID_PERCENTAGE_SET,
    CONFIRM_LIST_NFT_DIALOG_HIDE,
    CONFIRM_LIST_NFT_DIALOG_SHOW,
    DE_LISTED_DIALOG_HIDE,
    DE_LISTED_DIALOG_SHOW,
    END_DATE_SET,
    IBC_TOKENS_LIST_FETCH_ERROR,
    IBC_TOKENS_LIST_FETCH_IN_PROGRESS,
    IBC_TOKENS_LIST_FETCH_SUCCESS,
    LIST_NFT_DIALOG_HIDE,
    LIST_NFT_DIALOG_SHOW,
    LIST_NFT_SUCCESS_DIALOG_HIDE,
    LIST_NFT_SUCCESS_DIALOG_SHOW,
    LIST_TYPE_SET,
    LISTINGS_FETCH_ERROR,
    LISTINGS_FETCH_IN_PROGRESS,
    LISTINGS_FETCH_SUCCESS,
    SPLIT_INFO_SET,
    SPLIT_INFO_STATUS_SET,
    START_DATE_SET,
    WHITELIST_SWITCH_SET,
    WHITELIST_VALUE_SET,
} from '../../constants/createAssets/listing';
import { urlFetchListings } from '../../constants/restURL';
import Axios from 'axios';
import { IBC_TOKENS_LIST_URL } from '../../constants/url';
import { handleErrorMessage } from '../../utils/errorMessages';

export const showListNFTDialog = (value) => {
    return {
        type: LIST_NFT_DIALOG_SHOW,
        value,
    };
};

export const setBidPercentagePrice = (value) => {
    return {
        type: BID_PERCENTAGE_SET,
        value,
    };
};

export const setWhiteListSwitch = (value) => {
    return {
        type: WHITELIST_SWITCH_SET,
        value,
    };
};

export const setWhiteListValue = (value) => {
    return {
        type: WHITELIST_VALUE_SET,
        value,
    };
};

export const setListingStartDate = (value) => {
    return {
        type: START_DATE_SET,
        value,
    };
};

export const setListingEndDate = (value) => {
    return {
        type: END_DATE_SET,
        value,
    };
};

export const setListType = (value) => {
    return {
        type: LIST_TYPE_SET,
        value,
    };
};

export const hideListNFTDialog = () => {
    return {
        type: LIST_NFT_DIALOG_HIDE,
    };
};

export const showConfirmListNFTDialog = (value) => {
    return {
        type: CONFIRM_LIST_NFT_DIALOG_SHOW,
        value,
    };
};

export const hideConfirmListNFTDialog = () => {
    return {
        type: CONFIRM_LIST_NFT_DIALOG_HIDE,
    };
};

export const showListNFTSuccessDialog = (info, value, deList) => {
    return {
        type: LIST_NFT_SUCCESS_DIALOG_SHOW,
        info,
        value,
        deList,
    };
};

export const hideListNFTSuccessDialog = () => {
    return {
        type: LIST_NFT_SUCCESS_DIALOG_HIDE,
    };
};

export const showDeListedDialog = (value) => {
    return {
        type: DE_LISTED_DIALOG_SHOW,
        value,
    };
};

export const hideDeListedDialog = () => {
    return {
        type: DE_LISTED_DIALOG_HIDE,
    };
};

const fetchListingsInProgress = () => {
    return {
        type: LISTINGS_FETCH_IN_PROGRESS,
    };
};

const fetchListingsSuccess = (value, skip, limit, search, total) => {
    return {
        type: LISTINGS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        search,
        total,
    };
};

const fetchListingsError = (message) => {
    return {
        type: LISTINGS_FETCH_ERROR,
        message,
    };
};

export const fetchListings = (address, skip, limit, search, priceDenom, minPrice, maxPrice, cb) => (dispatch) => {
    dispatch(fetchListingsInProgress());

    const url = urlFetchListings(address, skip, limit, search, priceDenom, minPrice, maxPrice);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchListingsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, search, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res && res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchListingsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const fetchIBCTokensListInProgress = () => {
    return {
        type: IBC_TOKENS_LIST_FETCH_IN_PROGRESS,
    };
};

const fetchIBCTokensListSuccess = (value) => {
    return {
        type: IBC_TOKENS_LIST_FETCH_SUCCESS,
        value,
    };
};

const fetchIBCTokensListError = (message) => {
    return {
        type: IBC_TOKENS_LIST_FETCH_ERROR,
        message,
    };
};

export const fetchIBCTokensList = () => (dispatch) => {
    dispatch(fetchIBCTokensListInProgress());

    Axios.get(IBC_TOKENS_LIST_URL, {
        headers: {
            Accept: 'application/json, text/plain, */*',
        },
    })
        .then((res) => {
            dispatch(fetchIBCTokensListSuccess(res.data && res.data.result));
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchIBCTokensListError(message));
        });
};

export const setSplitInfo = (value) => {
    return {
        type: SPLIT_INFO_SET,
        value,
    };
};

export const setSplitInfoStatus = (value) => {
    return {
        type: SPLIT_INFO_STATUS_SET,
        value,
    };
};
